/** @format */

import React, { useState, useRef, useEffect, useCallback } from "react";

const MultiSelectDropdown = ({ options, selected = [], onChange, placeholder = "Select...", required, name }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const hiddenRef = useRef(null);

  const handleClickOutside = useCallback((e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [handleClickOutside]);

  const toggleOption = (val) => {
    const next = selected.includes(val)
      ? selected.filter((v) => v !== val)
      : [...selected, val];
    onChange(next);
  };

  const displayText = selected.length > 0 ? selected.join(", ") : placeholder;

  return (
    <div ref={ref} style={{ position: "relative" }}>
      {/* Hidden select for form validation */}
      {required && (
        <select
          ref={hiddenRef}
          name={name}
          multiple
          required
          value={selected}
          onChange={() => {}}
          style={{ position: "absolute", opacity: 0, height: 0, width: 0, pointerEvents: "none" }}
          tabIndex={-1}
        >
          {options.map((opt, i) => (
            <option key={i} value={opt}>{opt}</option>
          ))}
        </select>
      )}
      <button
        type="button"
        className="form-control text-left d-flex justify-content-between align-items-center"
        onClick={() => setOpen((prev) => !prev)}
        style={{ cursor: "pointer", minHeight: "38px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
      >
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{displayText}</span>
        <i className="fal fa-chevron-down ml-2" style={{ fontSize: "0.75rem", flexShrink: 0 }}></i>
      </button>
      {open && (
        <div
          className="border bg-white shadow-sm"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 1050,
            maxHeight: "200px",
            overflowY: "auto",
            borderRadius: "4px",
          }}
        >
          {options.map((opt, i) => {
            const isSelected = selected.includes(opt);
            return (
              <button
                key={i}
                type="button"
                className={`dropdown-item d-flex align-items-center justify-content-between py-2${isSelected ? " active" : ""}`}
                onClick={() => toggleOption(opt)}
                style={{ cursor: "pointer", fontSize: "0.9rem" }}
              >
                {opt}
                {isSelected && <i className="fal fa-circle-xmark ml-2" style={{ fontSize: "0.85rem" }}></i>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
